import LicenseSvg from "@/assets/license.svg?url";
import LiveSimulationsSvg from "@/assets/live_simulations.svg?url";
import ManagementSvg from "@/assets/management.svg?url";
import ModelsSvg from "@/assets/models.svg?url";
import PersonalApiKeysSvg from "@/assets/personal_api_keys.svg?url";
import SchematisationsSvg from "@/assets/schematisations.svg?url";
import SimulationsSvg from "@/assets/simulations.svg?url";

import { isEnabled } from "../features";

export interface Tile {
  title: string;
  icon: string;
  linksTo: string;
  linksToExternal?: boolean;
  disabled?: boolean;
  requiresManager?: boolean;
}

export interface Tiles {
  [path: string]: Tile[];
}

export const tiles: Tiles = {
  "": [
    ...(isEnabled("allModels")
      ? [
          {
            title: "Schematisations",
            icon: SchematisationsSvg,
            linksTo: "/schematisations",
            disabled: false,
          },
          {
            title: "Models",
            icon: ModelsSvg,
            linksTo: "/models",
            disabled: false,
          },
          {
            title: "Personal Api Keys",
            icon: PersonalApiKeysSvg,
            linksTo: "/personal_api_keys",
            disabled: false,
          },
        ]
      : []),
    {
      title: "Simulations",
      icon: SimulationsSvg,
      linksTo: "/simulations",
      disabled: false,
    },
    ...(isEnabled("liveSimulations")
      ? [
          {
            title: "Live simulations",
            icon: LiveSimulationsSvg,
            linksTo: "/live",
            disabled: false,
          },
        ]
      : []),
    ...(isEnabled("allManagement")
      ? [
          {
            title: "Management",
            icon: ManagementSvg,
            linksTo: "/management",
            disabled: false,
          },
        ]
      : []),
  ],
  "/management": isEnabled("allManagement")
    ? [
        {
          title: "License",
          icon: LicenseSvg,
          linksTo: "/management/license",
          disabled: true,
        },
      ]
    : [],
};
